import React, { useEffect, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";

import Confirm from './confrim';
import {STRIPEPUBLICKEY,STRIPESECRETKEY} from '../../../backend'
const ConfirmEle = () => {
    // const stripePromise = loadStripe('pk_test_51NtSnlLKpVRgqWxom6iTaBorBjLi2pN6xJZIsOOwHcnwrEPGUZZdX0DlPrtyvsCrXyfAWkjvo4ApMNles7mwWvrD00lXbFgo1d');
    const stripePromise = loadStripe(STRIPEPUBLICKEY);
 
    const [client,setClient]  =useState('')
      useEffect(()=>{
        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
          );
          setClient(clientSecret)
      },[])
  return (
    <div>
         {client && (
         <Elements stripe={stripePromise} options={{ clientSecret: client }}>
            <Confirm/>
     </Elements>
          ) 
}
    </div>
  )
}

export default ConfirmEle